export default "__VITE_ASSET__6c5d0b11__"